import { render, staticRenderFns } from "./PrintShops.vue?vue&type=template&id=8212b1d0&scoped=true"
import script from "./PrintShops.vue?vue&type=script&lang=js"
export * from "./PrintShops.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8212b1d0",
  null
  
)

export default component.exports